"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _immutable = require("immutable");
var _TransmuteCollection = require("./TransmuteCollection");
_TransmuteCollection.every.implement(Array, (predicate, arr) => {
  return arr.every(predicate);
});
_TransmuteCollection.every.implementInherited(_immutable.Iterable, (test, iter) => iter.every(test));
_TransmuteCollection.every.implement(Object, (predicate, obj) => {
  const keys = Object.keys(obj);
  const len = keys.length;
  for (let i = 0; i < len; i++) {
    const key = keys[i];
    if (!predicate(obj[key], key, obj)) {
      return false;
    }
  }
  return true;
});
var _default = exports.default = _TransmuteCollection.every;
module.exports = exports.default;